export const AddModeratorIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
    >
      <rect width="28" height="28" rx="14" fill="#F4F4F4" />
      <mask
        id="mask0_4433_585"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="4"
        y="4"
        width="20"
        height="20"
      >
        <rect x="4" y="4" width="20" height="20" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_4433_585)">
        <path
          d="M14 22C12.1528 21.5833 10.6076 20.5382 9.36458 18.8646C8.12153 17.191 7.5 15.3264 7.5 13.2708V8.5L14 6L20.5 8.5V13.1042C20.1944 12.9653 19.9236 12.8542 19.6875 12.7708C19.4514 12.6875 19.2222 12.6319 19 12.6042V9.52083L14 7.60417L9 9.52083V13.2708C9 13.9514 9.08681 14.6181 9.26042 15.2708C9.43403 15.9236 9.6875 16.5382 10.0208 17.1146C10.3542 17.691 10.7604 18.2188 11.2396 18.6979C11.7188 19.1771 12.2569 19.5972 12.8542 19.9583C12.9653 20.2778 13.1424 20.6146 13.3854 20.9688C13.6285 21.3229 13.8958 21.6528 14.1875 21.9583L14 22ZM17.9952 22C16.8873 22 15.9444 21.6095 15.1667 20.8285C14.3889 20.0477 14 19.1033 14 17.9952C14 16.8873 14.3905 15.9444 15.1715 15.1667C15.9523 14.3889 16.8967 14 18.0048 14C19.1127 14 20.0556 14.3905 20.8333 15.1715C21.6111 15.9523 22 16.8967 22 18.0048C22 19.1127 21.6095 20.0556 20.8285 20.8333C20.0477 21.6111 19.1033 22 17.9952 22ZM17.5 20H18.5V18.5H20V17.5H18.5V16H17.5V17.5H16V18.5H17.5V20Z"
          fill="#1C1B1F"
        />
      </g>
    </svg>
  );
};
